export default function Footer() {
    return (
        <div className="mt-auto" style={{ padding: '10px' }}>
            @PHMC
            <br />All the rights registered
        </div>
    );
}